// extracted by mini-css-extract-plugin
module.exports = {"form":"AddNewUserStyle_form__1XojX","mobileForm":"AddNewUserStyle_mobileForm__3X2Og","buttons":"AddNewUserStyle_buttons__pnri1"};